// This is generated.  Alter it in blockGroups/formElements/types/ReadOnlyDateTime.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Build the string schema with date/time format (always read-only, never optional)
    const stringOptions = {
      title: title,
      format: 'date-time',
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      readOnly: true,
    };

    const readOnlyDateTimeSchema = Type.String(stringOptions);

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: readOnlyDateTimeSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ReadOnlyDateTime',
  module.exports,
);
